<template>
    <div id="login" class="login-user" :class="$mq">
        <div class="anchor">
            <div class="login-topbar">
                <div v-if="alexIcon" class="andy-greetings" :class="{ 'only-head': true }" :style="{ backgroundImage: 'url(' + alexIcon + ')' }"></div>
                <div v-else class="andy-greetings" :class="{ 'only-head': true }"></div>
                <div class="avatar" :style="{ backgroundImage: 'url(' + locationData.avatar + ')' }"></div>

                <template v-if="['landscape', 'desktop'].includes($mq)">
                    <div class="location-card">
                        <div class="name">{{ locationData.name }}</div>
                        <div class="logout" @click="logout()"></div>
                    </div>
                </template>
            </div>
            <template v-if="['portrait'].includes($mq) && !selected">
                <div class="location-card">
                    <div class="name">{{ locationData.name }}</div>
                    <div class="more" :class="{ active: show_more }" @click="show_more = !show_more"></div>
                </div>
                <div class="more-layout" :class="{ active: show_more }">
                    <div class="logout" @click="logout">{{ $t('menu_aux.action.disconnect') }}</div>
                </div>
                <!-- SEARCH BAR -->
                <div v-if="Object.values(this.orderedUsers).length >= 10 && (!config || (config && !config.sso))" class="search-container">
                    <div class="search">
                        <input type="text" @input="updateSearchValue($event)" :value="searchValue" :placeholder="$t('login.search.placeholder')" class="search-input" />
                        <button v-if="searchValue.length > 0" @click="clearSearchInput" :aria-label="$t('login.search.clear')" class="close" />
                    </div>
                </div>
            </template>
            <template v-if="['landscape', 'desktop'].includes($mq)">
                <div class="help" @click="openTicketPopup()"></div>
            </template>
            <!-- <div class="offline-icon"></div> -->

            <div class="login-container hide-scrollbar" :class="{ condensed: selected }" v-if="!config || (config && !config.sso)">
                <div class="access-container" :class="{ condensed: selected }">
                    <template v-if="!selected && Object.values(employees).length != 0">
                        <div v-if="['landscape', 'desktop'].includes($mq)" class="access-header">
                            <div class="login-roles" ref="loginRolesContainer" v-if="Object.keys(rolesShowMore).length > 1 || Object.keys(roles).length != 0">
                                <div class="login-roles-title">
                                    {{ $t('login.filtering_role') }}
                                </div>

                                <div class="roles" v-if="showLess">
                                    <div class="role" :class="{ selected: selectedRole === 'all' }" @click="selectedRole = 'all'">{{ $t('login.all_roles') }}</div>
                                    <div class="role-container" v-for="(value, key, index) in rolesShowMore" :key="key">
                                        <div class="role" :class="{ selected: selectedRole === value.id }" @click="() => changeSelectedRole(value.id)">
                                            {{ value.name }}
                                        </div>
                                    </div>
                                    <div v-if="showLess && noMoreRoles()" class="show-less more" @click="heightRoleContainer(true)">{{ $t('login.show_more') }}</div>
                                </div>

                                <div class="roles" v-else>
                                    <div class="role" :class="{ selected: selectedRole === 'all' }" @click="selectedRole = 'all'">{{ $t('login.all_roles') }}</div>
                                    <div class="role-container" v-for="(value, key, index) in roles" :key="key">
                                        <div class="role" :class="{ selected: selectedRole === value.id }" @click="() => changeSelectedRole(value.id)">
                                            {{ value.name }}
                                        </div>
                                    </div>
                                    <div v-if="!showLess" class="show-less" @click="heightRoleContainer(true)">{{ $t('login.show_less') }}</div>
                                </div>
                            </div>
                            <!-- SEARCH BAR -->
                            <div class="search-container">
                                <div class="search">
                                    <input type="text" @input="updateSearchValue($event)" :value="searchValue" :placeholder="$t('login.search.placeholder')" class="search-input" />
                                    <button v-if="searchValue.length > 0" @click="clearSearchInput" :aria-label="$t('login.search.clear')" class="close" />
                                </div>
                            </div>
                        </div>

                        <!-- <div :style="{ height: 'calc(100% - ' + heightRoles + 'px)' }" class="cards-employee-container scrollbar"> -->
                        <transition-group @before-leave="beforeLeave" :style="{ height: 'calc(100% - ' + heightRoles + 'px)' }" class="cards-employee-container scrollbar" name="list" tag="div">
                            <employee :class="{ selected: employeeSelected.id == employee.id }" :employee="employee" @click="select(employee)" :rol="getRol(employee)" v-for="employee in employeesList" :key="employee.id"></employee>
                            <div v-if="callLoginUsers" class="link-logout" @click="goToLogoutExternal(true)" key="logout">
                                <div class="img-logout"></div>
                                <div class="question" v-html="$t('login.logout_external')"></div>
                            </div>
                            <!-- <div class="link-helpcenter" @click="goToHelpCenter(true)">
                                <div class="img-question"></div>
                                <div class="question" v-html="$t('login.how_to_add_users')"></div>
                            </div> -->
                        </transition-group>
                        <!-- </div> -->
                    </template>

                    <template v-else-if="selected">
                        <div class="set-password">
                            <employee class="selected no-click" :class="{ 'employee-small': windowHeight < 700 }" :employee="employeeSelected" @click="select(employeeSelected)" :rol="getRol(employeeSelected)"></employee>
                            <loginPassword :class="{ disabled: !selected }" @back="closeNumpad()" :employeeSelected="employeeSelected"></loginPassword>
                        </div>
                    </template>

                    <template v-else>
                        <EmptyPage @buttonAction="refresh" :title="$t('empty_pages.login')" type="login" :description="$t('empty_pages.login_description')" :buttonText="$t('popup.update.text_download')" buttonClass="refresh"></EmptyPage>
                    </template>
                </div>
            </div>
            <div v-else-if="config && config.sso" class="login-container hide-scrollbar">
                <div class="saml-container">
                    <p>{{ $t('login.saml.description') }}</p>
                    <span class="saml-button" @click="goToSamlLogin()">{{ $t('login.saml.button') }}</span>
                </div>
            </div>
        </div>
        <template v-if="['landscape', 'desktop'].includes($mq)">
            <div class="version">{{ $t('tooltip.version') }}: {{ appVersion }}</div>
        </template>
    </div>
</template>

<script>
import EmptyPage from '../../layout/EmptyPage.vue'
import Message from '@/components/domain/ui/Message.vue'
import employee from '@/components/domain/login/employee'
import loginPassword from '@/components/domain/login/loginPassword'

export default {
    components: {
        employee,
        loginPassword,
        Message,
        EmptyPage
    },
    name: 'connect',
    data() {
        return {
            selected: false,
            employeeSelected: {},
            selectedRole: 'all',
            employeesList: [],
            limiter: 3,
            showLess: true,
            heightRoles: 0,
            windowWidth: 0,
            windowHeight: 0,

            // PORTRAIT LOGIC
            show_more: false,

            // search bar
            searchValue: '',
            searchTimer: null
        }
    },
    computed: {
        isApp() {
            return this.$store.getters['getIsApp']
        },
        alexIcon() {
            return this.$store.getters.getAppIcon
        },
        rolesShowMore() {
            var aRoles = []
            var result = {}
            if (this.roles) {
                for (var role in this.roles) {
                    var idx = this.roles[role]
                    if (idx.level == 1 || idx.level == 2 || idx.level == 3) {
                        aRoles.push(idx)
                    }
                }
                var result = Object.entries(aRoles)
                    .sort(([, a], [, b]) => a - b)
                    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})
                return result
            }
            return result
        },
        locationData() {
            return this.$store.getters['loginUser/getLocalLocation']
        },
        employees() {
            var employees = this.$store.getters['employee/getLoginUsers']()
            var empls = {}
            for (var k in employees) {
                if (employees[k].password != null && employees[k].password != 'null' && ((typeof employees[k].access_app !== 'undefined' && employees[k].access_app) || (typeof employees[k].app_access !== 'undefined' && employees[k].app_access))) empls[k] = employees[k]
            }

            return empls
        },
        roles() {
            var roles = this.$store.getters['employee/getAllRoles']
            var oRoles = {}

            for (var key in this.employees) {
                var empl = this.employees[key]
                if (typeof oRoles[empl.rol] === 'undefined' && typeof roles[empl.rol] !== 'undefined') {
                    oRoles[empl.rol] = roles[empl.rol]
                }
            }
            // sort roles by level
            var sortables = []
            for (var role in oRoles) {
                sortables.push(oRoles[role])
            }

            sortables.sort(function (a, b) {
                return a.level - b.level
            })
            var result = Object.entries(sortables)
                .sort(([, a], [, b]) => a - b)
                .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})

            return result
        },
        orderedUsers: function () {
            if (this.employees) {
                var employees = Object.values(this.employees).sort(function (a, b) {
                    if (cleanString(a.name) < cleanString(b.name)) {
                        return -1
                    }
                    if (cleanString(a.name) > cleanString(b.name)) {
                        return 1
                    }
                    return 0
                })
                return Object.assign({}, employees)
            }
            return false
        },
        appVersion() {
            return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : ''
        },
        callLoginUsers() {
            return this.$store.getters.getCallLoginUsers
        },
        errorValidatingExternalLogin() {
            const error = this.$store.getters['employee/getErrorValidatingExternalLogin']
            return error
        },
        typeOfError() {
            const error = this.$store.getters['employee/getTypeOfValidatingExternalLogin']
            return error
        },
        config() {
            return this.$store.getters['login/getConfig']
        }
    },
    methods: {
        refresh() {
            let self = this
            self.$store.dispatch('employee/loadEmployees', { force: true }).then(function (response) {
                self.$store.dispatch('employee/loadRoles').then(function (response2) {})
            })
        },
        goToSamlLogin() {
            if (fnCheckConnection()) {
                const url = this.config && this.config.sso && this.config.sso.saml_url ? this.config.sso.saml_url : 'auth/login/sonae'
                if (!this.isApp) {
                    window.location.href = process.env.VUE_APP_API_URL + '/' + url + '?environment=app&location=' + this.locationData.id + '&platform=2'
                } else {
                    cordova.InAppBrowser.open(process.env.VUE_APP_API_URL + '/' + url + '?environment=app&location=' + this.locationData.id + '&platform=1', '_system')
                }
            } else {
                this.$popup.alert({
                    message: self.$t('login.errors.external_login_offline')
                })
            }
        },
        beforeLeave(el) {
            const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
            el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 50)}px`
            el.style.top = `${el.offsetTop - parseFloat(marginTop, 50)}px`
            el.style.width = width
            el.style.height = height
        },
        noMoreRoles() {
            if (this.roles) {
                for (let i = 0; i < Object.values(this.roles).length; i++) {
                    const element = this.roles[i]
                    if (element.level != 1 && element.level != 2 && element.level != 3) {
                        return true
                    }
                }
                return false
            }
        },
        heightRoleContainer(button) {
            if (button) {
                this.showLess = !this.showLess
            }
            var roleContainer = ''
            var self = this
            this.$nextTick(() => {
                if (typeof self.$refs.loginRolesContainer !== 'undefined' && typeof self.$refs.loginRolesContainer.clientHeight !== 'undefined') {
                    roleContainer = self.$refs.loginRolesContainer.clientHeight + 10
                    self.heightRoles = roleContainer
                }
            })
        },
        logout() {
            var self = this
            // get changes to sync before ask for logout
            let changesToSyncronize = false
            this.$store.dispatch('getCountSyncItems').then((count) => {
                changesToSyncronize = count
                if (count > 0) {
                    self.$popup.confirm({
                        message: self.$tc('config.changes_sync') + ' ' + self.$tc('config.changes_sync_logout', changesToSyncronize, { number: changesToSyncronize }) + ' ' + self.$tc('config.changes_sync_logout2', changesToSyncronize) + ' ' + self.$tc('config.changes_sync_logout3'),
                        // title: self.$t('popup.confirm.title'),
                        textSave: self.$t('popup.confirm.stay_conected'),
                        textCancel: self.$t('popup.cancel.close_session'),
                        callSave: function () {
                            self.$popup.close()
                        },
                        callCancel: function () {
                            self.$store.dispatch('login/logout').then(function () {
                                if (false && process.env.VUE_APP_IS_APP == 'TRUE') {
                                    //CLEAN FOLDER WITH ALEX FILE PRINTER CONFIGURATION
                                    // window.resolveLocalFileSystemURL(
                                    //     cordova.file.externalRootDirectory + 'ALEX',
                                    //     function (fileSystem) {
                                    //         var reader = fileSystem.createReader()
                                    //         reader.readEntries(
                                    //             function (entries) {
                                    //                 entries.forEach((entry) => {
                                    //                     entry.remove(
                                    //                         function () {},
                                    //                         function (error) {}
                                    //                     )
                                    //                 })
                                    //                 self.$router.push('/login').then(function () {
                                    //                     location.reload()
                                    //                 })
                                    //             },
                                    //             function (err) {
                                    //                 log(err)
                                    //             }
                                    //         )
                                    //     },
                                    //     function (err) {
                                    //         log(err)
                                    //     }
                                    // )
                                } else {
                                    self.$router.push('/login').then(function () {
                                        location.reload()
                                    })
                                }
                            })
                        }
                    })
                } else {
                    self.$popup.disconnect({
                        message: self.$t('login.logout_desc', { location: self.locationData.name }),
                        textSave: self.$t('popup.local_logout.text_save'),
                        textCancel: self.$t('popup.local_logout.text_cancel'),
                        callSave: function () {
                            // self.$router.push('/login')
                            self.$store.dispatch('login/logout').then(function () {
                                if (false && process.env.VUE_APP_IS_APP == 'TRUE') {
                                    //CLEAN FOLDER WITH ALEX FILE PRINTER CONFIGURATION
                                    // window.resolveLocalFileSystemURL(
                                    //     cordova.file.externalRootDirectory + 'ALEX',
                                    //     function (fileSystem) {
                                    //         var reader = fileSystem.createReader()
                                    //         reader.readEntries(
                                    //             function (entries) {
                                    //                 entries.forEach((entry) => {
                                    //                     entry.remove(
                                    //                         function () {},
                                    //                         function (error) {}
                                    //                     )
                                    //                 })
                                    //                 self.$router.push('/login').then(function () {
                                    //                     location.reload()
                                    //                 })
                                    //             },
                                    //             function (err) {
                                    //                 log(err)
                                    //             }
                                    //         )
                                    //     },
                                    //     function (err) {
                                    //         log(err)
                                    //     }
                                    // )
                                } else {
                                    self.$router.push('/login').then(function () {
                                        location.reload()
                                    })
                                }
                            })
                        }
                    })
                }
            })
        },
        goToHelpCenter(link) {
            if (link) {
                var link = document.getElementById('link').getAttribute('href')
                if (this.isApp) {
                    cordova.InAppBrowser.open(link, '_system')
                } else {
                    window.open(link)
                }
            } else {
                if (this.isApp) {
                    cordova.InAppBrowser.open('https://help.andyapp.io/portal/es/kb/articles/https-desk-zoho-eu-portal-andyapp-en-kb-articles-anadirusuario', '_system')
                } else {
                    window.open('https://help.andyapp.io/portal/es/kb/articles/https-desk-zoho-eu-portal-andyapp-en-kb-articles-anadirusuario')
                }
            }
        },
        goToLogoutExternal() {
            if (!this.isApp) {
                window.location.href = process.env.VUE_APP_API_URL + 'logout/externalcurrent?authorization=' + this.$store.getters['login/getToken'] + '&platform=2'
            } else {
                cordova.InAppBrowser.open(process.env.VUE_APP_API_URL + 'logout/externalcurrent?authorization=' + this.$store.getters['login/getToken'] + '&platform=1', '_system')
            }
        },
        load() {
            // CLOSE POPUP & SNACKBAR & OVERLAY & BAR
            this.$snackbar.close()
            this.$overlay.hide()
            this.$bar.hide()

            // PORTRAIT LOCK
            if (['portrait'].includes(this.$mq) && this.isApp && !this.$store.getters.getIsIOS) {
                screen.orientation.lock('portrait')
            }

            if (this.errorValidatingExternalLogin) {
                var self = this
                const iTime = 200
                const msg = this.typeOfError == 'location' ? self.$t('login.errors.external_login_wrong_location') : self.$t('login.errors.external_login_wrong_user')
                setTimeout(() => {
                    // self.$snackbar.error({ closeable: true, message: self.$t('login.errors.external_login_wrong_user'), duration: 10000 })
                    self.$popup.alert({
                        message: msg
                    })
                    self.$store.commit('employee/setErrorValidatingExternalLogin', false)
                }, iTime)
            }

            this.selectedRole = 'all'
        },

        changeSelectedRole(roleId) {
            this.selectedRole = roleId
        },

        filterAllEmployeesByRole() {
            const allEmployees = Object.values(structuredClone(this.orderedUsers))

            if (this.selectedRole === 'all') {
                this.employeesList = allEmployees
            } else {
                const filteredListByRole = allEmployees.filter((employee) => employee.rol == this.selectedRole)

                this.employeesList = filteredListByRole
            }
        },

        filterBySearchInput() {
            const currentEmployeesList = Object.values(structuredClone(this.employeesList))

            const filteredListBySearchInput = currentEmployeesList.filter((employee) => {
                const searchValue = this.normalizeStr(this.searchValue.trim().toLowerCase())

                const name = this.normalizeStr(employee.name.toLowerCase())
                const surname = this.normalizeStr(employee.surname.toLowerCase())
                const nameAndSurname = `${name} ${surname}`
                const surnameAndName = `${surname} ${name}`

                return name.includes(searchValue) || surname.includes(searchValue) || nameAndSurname.includes(searchValue) || surnameAndName.includes(searchValue)
            })

            if (filteredListBySearchInput.length === 0) {
                this.employeesList = []
            } else {
                this.employeesList = filteredListBySearchInput
            }
        },

        // SEARCH
        filterEmployeesList() {
            this.filterAllEmployeesByRole()
            this.filterBySearchInput()
        },

        select(employee) {
            if (this.employeeSelected == employee) {
                this.employeeSelected = {}
                this.selected = false
            } else {
                if (!this.callLoginUsers) {
                    this.employeeSelected = employee
                    this.selected = true
                } else {
                    log('Lanzo call api', employee)
                    if (fnCheckConnection()) {
                        this.$store.commit('employee/setCurrentEmployeeValidatingExternal', employee.id)
                        if (!this.isApp) {
                            window.location.href = process.env.VUE_APP_API_URL + 'login/externaluser?authorization=' + this.$store.getters['login/getToken'] + '&id=' + employee.id + '&platform=2'
                        } else {
                            cordova.InAppBrowser.open(process.env.VUE_APP_API_URL + 'login/externaluser?authorization=' + this.$store.getters['login/getToken'] + '&id=' + employee.id + '&platform=1', '_system')
                        }
                    } else {
                        this.$popup.alert({
                            message: self.$t('login.errors.external_login_offline')
                        })
                    }
                }
            }
        },
        getRol(employee) {
            if (employee.rol) {
                return this.$store.getters['employee/getRol'](employee.rol)
            } else {
                return false
            }
        },
        closeNumpad() {
            this.employeeSelected = ''
            this.selected = false
        },
        openTicketPopup() {
            window.open('https://help.andyapp.io/', '_blank')
        },
        getWindowWidth(event) {
            this.windowWidth = document.documentElement.clientWidth
            this.heightRoleContainer(false)
        },
        getWindowHeight(event) {
            this.windowHeight = document.documentElement.clientHeight
            this.heightRoleContainer(false)
        },

        updateSearchValue(e) {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
                this.searchTimer = null
            }

            this.searchTimer = setTimeout(() => {
                this.searchValue = e.target.value
            }, 300)
        },
        clearSearchInput() {
            this.searchValue = ''
        },
        normalizeStr(string) {
            return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        }
    },

    watch: {
        errorValidatingExternalLogin(newVal, oldVal) {
            log('errorValidatingExternalLogin', newVal)
            this.load()
        },

        selectedRole() {
            this.filterEmployeesList() // SEARCH
        },

        searchValue() {
            this.filterEmployeesList() // SEARCH
        }
    },

    created() {
        this.load()
    },
    mounted() {
        // Disconnect if user press back button on mobile

        var self = this
        if (this.isApp) {
            document.addEventListener('backbutton', function () {
                self.$popup.disconnect({
                    message: self.$t('login.logout_desc', { location: self.locationData.name }),
                    textSave: self.$t('popup.local_logout.text_save'),
                    textCancel: self.$t('popup.local_logout.text_cancel'),
                    callSave: function () {
                        // self.$router.push('/login')
                        self.$store.dispatch('login/logout').then(function () {
                            self.$router.push('/login').then(function () {
                                location.reload()
                            })
                        })
                    }
                })
            })
        } else {
            history.pushState(null, null, location.href)
            window.onpopstate = function () {
                history.go(1)
                self.$popup.disconnect({
                    message: self.$t('login.logout_desc', { location: self.locationData.name }),
                    textSave: self.$t('popup.local_logout.text_save'),
                    textCancel: self.$t('popup.local_logout.text_cancel'),
                    callSave: function () {
                        // self.$router.push('/login')
                        self.$store.dispatch('login/logout').then(function () {
                            self.$router.push('/login').then(function () {
                                location.reload()
                            })
                        })
                    }
                })
            }
        }

        // EMPLOYEES LIST
        this.employeesList = this.orderedUsers

        if (['landscape', 'desktop'].includes(this.$mq)) {
            this.$nextTick(function () {
                // window.addEventListener('resize', this.getWindowWidth)
                window.addEventListener('resize', this.getWindowHeight)
                //Init
                this.getWindowWidth()
                this.getWindowHeight()
            })
            // this.heightRoleContainer()
        }
    },
    beforeDestroy() {
        if (this.isApp) {
            window.removeEventListener('backbutton', function () {
                self.$popup.disconnect({
                    message: self.$t('login.logout_desc', { location: self.locationData.name }),
                    textSave: self.$t('popup.local_logout.text_save'),
                    textCancel: self.$t('popup.local_logout.text_cancel'),
                    callSave: function () {
                        // self.$router.push('/login')
                        self.$store.dispatch('login/logout').then(function () {
                            self.$router.push('/login').then(function () {
                                location.reload()
                            })
                        })
                    }
                })
            })
        } else {
            window.onpopstate = function () {
                // history.go(0)
            }
        }
    },

    updated() {
        // if user uses back button, show popup disconnect

        if (this.selectedRole === 'all') {
            this.changeSelectedRole('all')
        }
        if (this.isApp) {
            document.getElementsByTagName('a').forEach((e) => {
                var link = e.href
                // e.href = ''
                e.setAttribute('onclick', 'return openLinkInApp(event,"' + link + '")')
            })
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.getWindowWidth)
        window.removeEventListener('resize', this.getWindowHeight)

        // ORIENTATION UNLOCK
        screen.orientation.unlock()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#login.login-user {
    $login-topbar-height: $menu-top-height;

    @include display-flex();
    @include flex-direction(row);
    @include justify-content();
    @include align-items();
    @include flex-wrap(nowrap);
    background-color: $default-bg-color;
    // background-image: img('circuit-board.svg');
    height: 100%;
    width: 100%;
    overflow: hidden;
    padding: 0px;
    padding-bottom: 30px;

    .search-container {
        position: relative;
        width: 100%;
        display: flex;
        align-items: flex-end;

        .search {
            position: relative;
            @include display-flex();
            @include align-items(center);
            @include background($image: img('search_neutro.svg'), $size: 25px, $position: left 12px center);
            @include border-radius(6.8px);
            @include font-size(ml);
            height: 44px;
            width: 100%;
            background-color: #fff;
            padding: 0 60px 0 45px;
            border-bottom: none;
            font-family: $text;
            cursor: text;
            border: 1px solid $color-neutral-300;

            .search-input {
                width: 100%;
                border-bottom: none;
                font-family: $text;
                // height: 44px;
                color: #222;
                font-size: 18px;
                background-color: #fff;
            }

            input::placeholder {
                color: $color-neutral-600;
                font-size: 18px;
            }
        }

        .close {
            @include border-radius(4px);
            @include background($image: img('close_dark.svg'), $size: 12px, $position: center center);
            width: 35px;
            height: 35px;
            position: absolute;
            right: 6px;
            bottom: 4px;
            background-color: $neutro-t50;
            cursor: pointer;
        }
    }

    .anchor {
        @include display-flex();
        @include flex-direction(column);
        width: calc(100%);
        max-width: calc(1200px);
        height: calc(100%);
        position: relative;
        overflow: visible;
    }

    .help {
        @include background($image: img('info_main_s10.svg'), $position: center center, $size: cover);
        width: 22px;
        height: 22px;
        position: absolute;
        left: 15px;
        bottom: 15px;
        cursor: pointer;
    }

    .offline-icon {
        display: none;
        @include background($image: img('no_signal_alert.svg'), $position: center center, $size: cover);
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.023 512.023' style='enable-background:new 0 0 512.023 512.023;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M507.343,484.687l-480-480c-6.24-6.24-16.384-6.24-22.624,0c-6.24,6.24-6.24,16.384,0,22.624l49.536,49.536 c-15.904,7.328-31.52,15.264-46.56,24.384c-3.648,2.208-6.272,5.824-7.264,9.984c-0.992,4.16-0.256,8.576,2.048,12.192 l42.784,67.968c25.536-16.832,53.28-30.528,82.528-40.96l25.472,25.472c-32.512,9.952-63.2,24.128-90.976,42.528l34.048,54.08 c32.64-21.824,70.272-36.192,110.464-43.072l28.16,28.16c-44.672,3.68-86.336,18.208-121.6,41.952l34.144,54.208 c30.912-21.216,68.256-33.728,108.512-33.728c16.48,0,32.384,2.304,47.616,6.24l181.056,181.056 c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C513.583,501.071,513.583,490.959,507.343,484.687z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M511.567,111.247c-0.96-4.16-3.584-7.776-7.264-10.016c-74.528-45.28-160.416-69.216-248.288-69.216 c-46.464,0-92.32,6.88-136.256,19.872l80.256,80.256c18.304-2.688,36.992-4.128,56-4.128c77.824,0,150.176,23.424,210.752,63.36 l42.784-67.936C511.823,119.791,512.591,115.408,511.567,111.247z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,160.015c-9.12,0-18.144,0.352-27.072,1.056l65.888,65.888c44.224,6.016,85.344,21.792,120.864,45.568 l34.048-54.112C394.127,181.583,327.567,160.015,256.015,160.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M337.647,269.775l48.928,48.928l12.064-19.168C379.951,286.959,359.375,277.103,337.647,269.775z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,352.015c-33.984,0-65.408,10.816-91.36,28.992l77.792,123.552c2.944,4.64,8.064,7.456,13.568,7.456 c5.504,0,10.624-2.816,13.536-7.456l77.792-123.552C321.423,362.831,289.999,352.015,256.015,352.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
        width: 24px;
        height: 24px;
        position: absolute;
        left: 20px;
        top: 80px;
    }

    .login-topbar {
        @include display-flex();
        @include justify-content(space-between);
        @include align-items(flex-start);
        width: 100%;
        text-align: center;
        height: $login-topbar-height;
        padding-top: $alex-app-padding;

        .andy-greetings {
            @include display-flex();
            @include align-items(center);
            height: 100%;

            &.only-head {
                @include background($image: img('alexhead_06.svg'));
                width: 60px;
                height: 60px;
            }
        }

        .avatar {
            @include opacity(0.8);
            background-repeat: no-repeat;
            background-size: contain;
            background-position: top center;
            width: 100%;
            height: rem(44px);
            line-height: initial;
            display: inline-block;
            cursor: auto;
            position: absolute;
            left: -2px;
        }

        .location-card {
            @include display-flex();
            @include border-radius(4px);
            @include align-items(center);
            background-color: #fff;
            box-shadow: 0px 0px 10px rgba(159, 162, 166, 0.498039);
            height: $menu-top-tools-height;
            z-index: 2;

            .name {
                @include background($size: 18px, $image: img('location_dark.svg'), $position: left 8px center);
                @include font-size(m);
                @include text-ellipsis();
                padding-left: 27px;
                color: #222;
                display: inline-block;
                width: fit-content;
                font-family: $conden-bold;
                height: rem(30px);
                line-height: rem(30px);
                max-width: 230px;
            }
            .logout {
                @include border-radius(50%);
                @include background($image: img('power_off_error.svg'), $size: 30px);
                background-color: $error-t70;
                width: 40px;
                height: 40px;
                margin: 0px 10px;
                cursor: pointer;
            }
            .login {
                margin-top: 0px;
            }
        }
    }

    .error {
        @include border-radius(3px);
        @include width-fit-content();
        @include font-size(xs);
        color: $error-s30;
        margin: 0 auto;
        background-color: $error-t60;
        padding: 9px;
    }

    .login-container {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(flex-start);
        height: calc(100% - #{$login-topbar-height});
        width: 100%;
        padding: $alex-app-padding 60px;
        overflow: hidden;
        max-width: 1410px;

        .saml-container {
            @include display-flex();
            @include flex-direction(column);
            @include align-items(center);
            @include justify-content(center);
            height: 100%;
            width: fit-content;
            margin: 0 auto;
            gap: 1.5rem;

            p {
                width: 80%;
                @include font-size(m);
                color: $main-dark;
                font-family: $text-bold;
            }

            .saml-button {
                width: 80%;
                padding: 1rem;
                background-color: $main;
                color: $color-white;
                font-family: $text-bold;
                @include font-size(m);
                @include display-flex();
                @include align-items(center);
                @include justify-content(center);
            }

        }

        .login-roles {
            @include align-self(flex-start);
            // margin-top: 15px;
            // margin-left: 10px;
            height: auto;

            .roles {
                @include display-flex();
                @include flex-wrap(wrap);
                width: 100%;
                // padding-bottom: 10px;
                overflow: auto;
                gap: 8px;
            }

            .show-less {
                @include background($image: img('up_arrow_neutro_s70.svg'), $color: $color-neutral-300, $size: 15px, $position: left 5px center);
                @include font-size(ml);
                @include border-radius(3px);
                font-family: $conden;
                padding-top: 8px;
                padding-bottom: 8px;
                padding-right: 9px;
                padding-left: 23px;
                color: $inactive-s70;
                // margin-left: 8px;
                cursor: pointer;
                height: 40px;
                //margin: 3px;

                &.more {
                    @include background($image: img('down_arrow_neutro_s70.svg'), $color: $color-neutral-300, $size: 15px, $position: left 5px center);
                }
                &:hover {
                    background-color: hover(#ecdddb, false);
                }
            }

            .login-roles-title {
                @include font-size(s);
                // font-family: $conden-bold;
                font-family: $text-bold;
                // color: $neutro-s60;
                padding-bottom: 8px;
                color: $inactive-s70;
            }

            .role {
                @include interaction();
                @include border-radius(4px);
                @include font-size(ml);
                color: $inactive-s70;
                font-family: $conden;
                line-height: 40px;
                height: 40px;
                display: inline-block;
                padding: 0 12px;
                // margin: 3px;

                &:hover {
                    background-color: hover($inactive-s70, true);
                }

                &.selected {
                    @include font-size(m);
                    // font-family: $conden-bold;
                    font-family: $text-bold;
                    // font-family: $conden;
                    background-color: $main;
                    color: #fff;
                    height: 40px;

                    &:hover {
                        background-color: hover($main);
                    }
                }
            }
        }

        .login-title {
            height: 50px;
            margin-bottom: 15px;

            .header {
                @include background($size: 50px, $image: img('alexhead_06.svg'), $position: left center);
                @include font-size(l);
                color: $main;
                font-family: $text-bold;
                text-align: left;
                height: 100%;
                line-height: 50px;
                width: auto;
                padding-left: 60px;
            }
        }

        .access-container {
            @include default-box-shadow();
            @include border-radius(8px);
            @include align-self(center);
            background-color: $default-bg-color;
            width: 100%;
            padding: 10px 15px;
            // -3px para poder ver el sombreado
            min-height: calc(100% - 12px);

            .access-header {
                display: grid;
                grid-template-columns: 67% 33%;
                padding-bottom: 16px;
                padding-right: 4px;
            }

            .cards-employee-container {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-template-rows: auto;
                // grid-gap: 20px;
                grid-gap: 8px;
                align-items: start;
                align-content: start;
                justify-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                // padding: 0px 8px 0px 4px;
                padding-right: 4px;

                .link-helpcenter,
                .link-logout,
                .employee-container {
                    width: 100%;
                    // min-width: unset;
                    height: auto;
                    min-height: 60px;
                    margin: 0;
                }

                .employee-container {
                    display: flex;
                    gap: 8px;
                    padding-left: 14px;
                }

                .link-helpcenter,
                .link-logout {
                    @include border-radius(9px);
                    @include display-flex();
                    @include flex-direction(column);
                    @include align-items(center);
                    background-color: #f5eceb;

                    .img-question {
                        @include background($image: img('help_circle_sharp.svg'));
                        width: 20px;
                        height: 20px;
                        margin-top: 10px;
                    }
                    .img-logout {
                        @include background($image: img('power_off_neutro_s70.svg'));
                        width: 20px;
                        height: 20px;
                        margin-top: 10px;
                    }
                    .question {
                        a {
                            @include font-size(s);
                            font-family: $text-bold;
                            color: $inactive-s50;
                        }
                        // margin-bottom: 10px;
                    }
                    &:hover {
                        background-color: hover(#f5eceb);
                        cursor: pointer;
                    }
                }

                .link-logout .question {
                    @include font-size(s);
                }

                @media (max-width: 599px) {
                    grid-template-columns: 1fr;
                }

                @media (min-width: 600px) and (max-width: 1000px) {
                    grid-template-columns: 1fr 1fr;
                }
            }
        }
    }
    .set-password {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(center);
        @include justify-content();
        height: 100;
        width: auto;
        // padding: 20px;
        height: 100%;

        .selected {
            height: 60px;
            width: 100%;
            width: 350px;
        }
    }

    .version {
        @include font-size(s);
        position: absolute;
        bottom: $alex-app-padding;
        right: $alex-app-padding * 2;
        color: $neutro-s20;
        font-family: $conden-light;
        padding: 0;
        margin: 0;
    }
}

.offline #login.login-user {
    .offline-icon {
        display: block;
    }
}

@media (orientation: portrait) {
    #login.login-user {
        @include flex-direction(column);

        .login-container {
            max-width: unset;
            height: 100%;

            &.condensed {
                .employees .employee-container:not(.selected),
                .login-title,
                .login-roles {
                    display: none;
                }
            }
        }
    }
}
@media (min-width: 1400px) {
    #login.login-user {
        .location-card {
            .name {
                max-width: 500px !important;
            }
        }
    }
}
// @media (max-width: 1000px) {
//     #login.login-user {
//         .anchor {
//             .login-topbar {
//                 .avatar {
//                     //TODO REVIEW
//                     // height: 30px;
//                 }
//             }
//         }
//         .access-container {
//             padding-bottom: 30px !important;
//             min-height: unset;

//             .set-password {
//                 padding: 0px;
//             }

//             &.condensed {
//                 padding-bottom: 8px !important;
//             }
//         }
//         .plugin {
//             margin-top: -5px;
//         }
//     }
// }
// @media (max-width: 600px) {
//     #login.login-user {
//         .anchor {
//             .login-topbar {
//                 padding: 0px 6px;

//                 .location-card {
//                     .name {
//                         @include font-size(sm);
//                         max-width: 150px;
//                     }
//                 }
//                 .andy-greetings {
//                     .login {
//                         .andy {
//                             width: 40px;
//                             height: 40px;
//                         }
//                         .message {
//                             width: calc(100% - 40px - 6px) !important;
//                             padding: 6px 9px !important;
//                         }
//                         .preview {
//                             @include font-size(sm);
//                         }
//                     }
//                 }
//                 .avatar {
//                     // TODO REVIEW
//                     // height: 25px;
//                 }
//             }
//         }
//         .access-container {
//             padding-bottom: 10px;
//             min-height: unset;

//             // .cards-employee-container {
//             //     .employee-container,
//             //     .link-helpcenter {
//             //         width: 100%;
//             //         max-width: 330px;
//             //     }
//             // }
//         }
//     }
// }
</style>

<!-- PORTRAIT STYLES -->
<style lang="scss">
#login.login-user.portrait {
    $topbar-height: 60px;
    padding-bottom: 0;

    .search-container {
        display: grid;
        place-items: center;
        padding: 0px 25px 0px 20px;

        @media screen and (min-width: 802px) {
            .search {
                width: 100% !important;
                max-width: 100% !important;
            }
        }
    }

    .offline-icon {
        left: 65px;
        top: 17px;
    }

    .login-topbar {
        // @include justify-content(left);
        width: 100%;
        position: relative;
        .andy-greetings {
            @include background($image: img('alexhead_06.svg'), $size: 40px);
            width: 60px;
            height: $topbar-height;
        }

        .avatar {
            height: 40px;
            width: 100%;
            margin-top: 10px;
            position: absolute;
            left: 0%;
        }
    }

    $location-card-height: calc(#{$topbar-height} - 5px);
    .location-card {
        @include display-flex();
        @include border-radius(3px);
        @include align-items(center);
        box-shadow: none;
        background-color: transparent;
        height: $location-card-height;
        max-height: unset;
        width: 100%;
        padding: 0px 0 0 7px;

        .name {
            @include font-size(s);
            @include background($size: 20px, $image: img('location_dark.svg'), $position: left 13px center);
            @include text-ellipsis();
            font-family: $text-bold;
            padding-left: 35px;
            padding-right: 5px;
            color: #222;
            display: inline-block;
            width: calc(100% - 60px);
            height: $location-card-height;
            line-height: 60px;
            max-width: calc(100% - 60px);
        }
        .more {
            @include background($size: 27px, $image: img('morebutton_inactive_s60.svg'), $position: center);
            margin-top: 0px;
            height: 100%;
            width: 60px;
            border-radius: 6px 0 0 0;
            cursor: pointer;

            &.active {
                @include background($size: 27px, $image: img('morebutton_fffff.svg'), $position: center);
                background-color: $main;
            }
        }
    }
    .more-layout {
        @include display-flex();
        @include align-items(center);
        background-color: $main;
        padding: 0;
        min-height: 0;
        // height: 0;
        width: 100%;
        transition: 0s ease-in-out 0s;
        overflow: hidden;
        transition: min-height 0.2s ease-in-out;
        position: absolute;
        top: 117px;
        z-index: 2;

        .logout {
            @include border-radius(3px);
            @include font-size(s);
            @include background($image: img('power_off_filled_error.svg'), $size: 30px, $position: left 15px center);
            cursor: pointer;
            font-family: $text-bold;
            background-color: #fff;
            line-height: 55px;
            padding-left: 60px;
            height: 0;
            width: 100%;
            overflow: hidden;
            margin: 0px 10px;
        }
        &.active {
            transition: min-height 0.2s ease-in-out;
            min-height: 80px;
            .logout {
                display: block;
                height: 55px;
                transition: 0.2s ease-in-out;
                margin: 7px 10px;
            }
        }
    }

    .login-container {
        width: 100%;
        padding: 0;
        border-radius: 0;
        height: 100%;

        .access-container {
            border-radius: 0;
            width: 100%;
            height: 100%;
            background-color: transparent;
            padding-bottom: 0 !important;
            min-height: unset !important;

            .employee-container {
                @media (max-width: 1000px) {
                    width: 100% !important;
                }
            }

            .cards-employee-container {
                width: 100%;
                padding-bottom: 30px;
                padding-right: 5px;
                padding-left: 5px;
                grid-gap: 12px;

                .link-helpcenter,
                .link-logout {
                    background-color: $neutro-t90;
                    max-width: 80% !important;

                    .img-question {
                        @include background($image: img('info_second.svg'));
                    }
                    .question {
                        a {
                            font-family: $text;
                            color: $neutro-s80;
                        }
                    }
                    &:hover {
                        background-color: $neutro-t90;
                    }
                }

                .link-logout .question {
                    @include font-size(xs);
                }
            }
        }

        .set-password {
            margin: 0px;
            padding: 0px;
            .employee-container {
                max-width: clamp(330px, 80%, 100%) !important;
            }
        }
    }
}
</style>
